import PropTypes from 'prop-types';
import React, { Component, memo } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import StaticContainer from 'react-static-container';
import get from 'lodash/get';
import flatten from 'lodash/flatten';
import uniqWith from 'lodash/uniqWith';
import isEmpty from 'lodash/isEmpty';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import { detectisEdge, detectisIE } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { selectPreferences } from 'yoda-site-components/lib/selectors/ContextSelector';
import CertonaZone from 'yoda-site-components/lib/components/CertonaZone/CertonaZone';
import BVSummary from 'yoda-site-components/lib/components/BVSummary/BVSummary';
import CouponExclusionBadge from 'yoda-site-components/lib/components/CouponExclusionBadge/CouponExclusionBadge';
import Quantity from 'yoda-site-components/lib/components/Quantity/Quantity';
import ProductTitle from 'yoda-site-components/lib/components/ProductTitle/ProductTitle';
import ProductPricing from 'yoda-site-components/lib/components/ProductPricing/ProductPricing';
import {
    productLotSelector,
    bopisIncentiveProductEligibilitySelector,
} from 'yoda-site-components/lib/selectors/ProductPricingSelector';
import selectRecPageType from 'yoda-site-components/lib/selectors/PDPPLASelector';
import selectProductType from 'yoda-site-components/lib/selectors/productDetails/selectProductType';
import ProductOptions from 'yoda-site-components/lib/components/ProductOptions/ProductOptions';
import EcoRebatesModal from 'yoda-site-components/lib/components/EcoRebates/EcoRebatesModal';
import FreestarAd from 'yoda-site-components/lib/components/FreestarAd/FreestarAdConnectLazy';
import Messages from 'yoda-site-components/lib/components/Messages';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import SpecialOffers from 'yoda-site-components/lib/components/SpecialOffers/SpecialOffers';
import { isCookieDisabled } from 'yoda-site-components/lib/helpers/Utils/parseOnetrust';
import {
    OPTANON_COOKIE,
    TRACKING,
} from 'yoda-site-components/lib/helpers/Utils/parseOnetrustConfig.config';
import { selectedProductSkus } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import { bopisIncentive } from 'yoda-site-components/lib/common/ProductConstants';
import { templateTypes } from 'yoda-site-components/lib/selectors/productDetails/selectProductType.config';
import IconArrowRight from '../../../../assets/png/Arrow_down.svg';
import { ADD_TO_CART_MESSAGES_ID } from '../../../../components/AddToCart/AddToCart.config';
import * as styles from '../PDP.css';
import Metadata from '../../../../components/Metadata/Metadata';
import AddToCart from '../../../../components/AddToCart/AddToCart';
import PDPBreadcrumbs from '../../../../components/PDPBreadcrumbs/PDPBreadcrumbs';
import BrandLink from '../../../../components/BrandLink/BrandLink';
import ProductModelNumber from '../../../../components/ProductModelNumber/ProductModelNumber';
import ProductImage from '../../../../components/ProductImage/ProductImage';
import Canonicalize from '../../../../components/Canonicalize/Canonicalize';
import ProductInfoMobile from '../../../../components/ProductInfo/ProductInfoMobile';
import ProductInfoDesktop from '../../../../components/ProductInfo/ProductInfoDesktop';
import MerchantMarketing from '../../../../components/MerchantMarketing/MerchantMarketingLazy';
import ProductCollection from '../../../../components/ProductCollection/ProductCollection';
import ShopTheLook from '../../../../components/ShopTheLook/ShopTheLookLazy';
import MixandMatch from '../../../../components/MixandMatch/MixandMatchLazy';
import DescriptionAndShipping from '../../../../components/DescriptionAndShipping/DescriptionAndShipping';
import IrisS1PromoBanner from '../../../../components/IrisS1PromoBanner/IrisS1PromoBanner';
import KeyFeatures from '../../../../components/KeyFeatures/KeyFeatures';
import VTO from '../../../../components/VirtualTryOn/VirtualTryOn';
import VTOToggle from '../../../../components/VirtualTryOn/VirtualTryOnToggle';
import { PLA_REC_PAGE_TYPE, HOW_TO_STYLE_IT } from '../../../../helpers/ProductConstants';
import getVirtualTryOnData from '../../../../selectors/VirtualTryOnSelector';
import { getMOQDropdownValue } from '../../../../selectors/QuantityDropDownSelector';
import BelowTheFold from '../../../../components/BelowTheFold/BelowTheFold';
import ProductOptionsErrorBanner from '../../../../components/ProductOptionsErrorBanner/ProductOptionsErrorBanner';

const cx = classNames.bind(styles);
export class Regular extends Component {
    static propTypes = {
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        analytics: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        query: PropTypes.oneOfType([PropTypes.object]),
        location: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        addToCartMessages: PropTypes.oneOfType([PropTypes.array]),
        ppId: PropTypes.string,
        isCollection: PropTypes.bool,
        slot1: PropTypes.element,
        slot2: PropTypes.element,
        slot4: PropTypes.element,
        slot5: PropTypes.element,
        isBeauty: PropTypes.bool,
        selectedProductLot: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        selectedLotPrice: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        bopisIncentiveProductEligibility: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productCollectionItems: PropTypes.oneOfType([PropTypes.object]),
        pdpProductType: PropTypes.object,
        isNative: PropTypes.bool,
        preferences: PropTypes.oneOfType([PropTypes.object]),
        virtualTryOn: PropTypes.oneOfType([PropTypes.object]),
        recPageType: PropTypes.string,
        quantityDropDownValue: PropTypes.number,
    };

    static defaultProps = {
        productDetails: {},
        pricing: {},
        location: {},
        query: {},
        featureFlags: {},
        deviceType: {},
        ppId: '',
        isCollection: false,
        slot1: null,
        slot2: null,
        slot4: null,
        slot5: null,
        isBeauty: false,
        addToCartMessages: [],
        selectedProductLot: [],
        selectedLotPrice: {},
        analytics: {},
        bopisIncentiveProductEligibility: {},
        productCollectionItems: {},
        pdpProductType: {},
        isNative: false,
        preferences: {},
        virtualTryOn: {},
        recPageType: '',
        quantityDropDownValue: 25,
    };

    constructor(props) {
        super(props);
        this.state = {
            isShopTheLook: {},
            jumpLinkImage: null,
            isOrientationLandscape: false,
            errorBannerMessage: null,
        };
    }

    componentDidMount() {
        if (this.props?.deviceType?.isMobile) {
            this.handleOrientationChange();
            window.addEventListener('resize', () => this.handleOrientationChange());
        }
    }

    componentWillUnmount() {
        if (this.props?.deviceType?.isMobile) {
            window.removeEventListener('resize', () => this.handleOrientationChange());
        }
    }

    renderPricingStack = (ppId, selectedLotPrice, deviceType, isBNPLeligible) => {
        const {
            featureFlags: { displayCouponExclusions = true },
        } = this.props;
        return (
            <section>
                <ErrorBoundary>
                    <div>
                        <ProductPricing
                            ppId={ppId}
                            couponExclusionMessage={selectedLotPrice.couponExclusionMessage}
                            deviceType={deviceType}
                            fpacPriceIndicator={selectedLotPrice.fpacDisplayIndicator}
                            isBNPLeligible={isBNPLeligible}
                        />
                        {displayCouponExclusions ? (
                            <CouponExclusionBadge
                                couponExclusionMessage={selectedLotPrice.couponExclusionMessage}
                            />
                        ) : null}
                    </div>
                </ErrorBoundary>

                <ErrorBoundary>
                    <SpecialOffers
                        fromMiniPDP={false}
                        deviceType={deviceType}
                        fpacPriceIndicator={selectedLotPrice.fpacDisplayIndicator}
                        isBNPLeligible={isBNPLeligible}
                        couponExclusionMessage={selectedLotPrice.couponExclusionMessage}
                    />
                </ErrorBoundary>
            </section>
        );
    };

    /* istanbul ignore next */
    outfitsData = (data) => {
        this.setState({
            isShopTheLook: data,
        });
    };

    /* istanbul ignore next */
    jumpLinkImage = (data) => {
        this.setState({
            jumpLinkImage: data,
        });
    };

    /* istanbul ignore next */
    handleOrientationChange = () => {
        const orientation = window && window?.matchMedia('(orientation: landscape)').matches;
        this.setState({
            isOrientationLandscape: orientation,
        });
    };

    getTop = (elem, deviceType = {}) => {
        const stickyHeaderHeight = 90;

        let result = elem.offsetTop;

        result = elem.offsetHeight !== 0 ? result - stickyHeaderHeight : result;

        return result;
    };

    scrollToShopTheLookOnJumplinkClick = () => {
        const shopTheLookSection = document && document.getElementById('widget-title');

        if (shopTheLookSection) {
            const top = this.getTop(shopTheLookSection, this.props.deviceType) + 70;
            /* istanbul ignore else */
            if (!detectisIE() && !detectisEdge()) {
                setTimeout(() => {
                    window.scrollTo({
                        top,
                        behavior: 'smooth',
                        block: 'start',
                    });
                }, 100);
            } else {
                shopTheLookSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        }
    };

    render() {
        const {
            productDetails,
            featureFlags,
            deviceType,
            ppId,
            query,
            isCollection,
            slot1,
            slot2,
            slot4,
            slot5,
            isBeauty,
            selectedProductLot,
            selectedLotPrice,
            analytics,
            bopisIncentiveProductEligibility,
            pdpProductType,
            isNative,
            preferences,
            virtualTryOn: { data = {} },
            recPageType,
            quantityDropDownValue,
        } = this.props;

        const isMTMOrVdata =
            pdpProductType.templateType === 'mtm' || pdpProductType.templateType === 'vdata';

        const { brand = {} } = productDetails;
        const [{ id: productId } = {}] = selectedProductLot;
        const { enableFreestarAdComponent = true, disableOldSkuBelow } = featureFlags;
        const isTrackingCookieActive = !isCookieDisabled(TRACKING, OPTANON_COOKIE);
        const productIcons = get(selectedProductLot[0], 'productIcons', []);
        /* istanbul ignore next */
        const valuesList = uniqWith(
            flatten(productIcons.map((item) => item.valueIcons)),
            (prevItem, nextItem) => prevItem.value === nextItem.value
        );
        const { isMobile: isMobileView, isDesktop: isDesktopView } = deviceType;
        const { isOrientationLandscape } = this.state;
        const rowClasses = disableOldSkuBelow
            ? [cx('row'), dt(['bg-white', 'm-0', 'px-0', 'pb-0'])].join(' ')
            : [dt(['bg-white', 'm-0', 'pt-4', 'px-0', 'pb-0']), cx('row')].join(' ');
        const productImageSectionClasses = [
            dt([
                'bg-white',
                'w-full',
                'm-0',
                'pb-10',
                'sm:!flex',
                'smOnly:flex-wrap',
                isMobileView ? `${'pt-0'}` : 'pt-2',
            ]),
            cx('row'),
        ].join(' ');
        const homeDivision = get(selectedProductLot, '[0].organization.division', '');
        const mixAndMatchDivisions = get(preferences, 'mixandMatch.mnmEligibleDivisions', '');
        const displayBopisIncentive = () => {
            const lotChannelOffering = get(selectedProductLot, '[0].channelOffering', '');
            /* istanbul ignore next */
            const isBopisIncentiveAvailable =
                bopisIncentiveProductEligibility.currentLotEligible &&
                productDetails.bopisEligibility &&
                lotChannelOffering !== 'OnlineOnly';
            return (
                /* istanbul ignore next */
                isBopisIncentiveAvailable ? (
                    <div className={cx('bopis-incentive-message')}>
                        <p
                            className={`${dt([
                                'text-urgency-border font-open-sans-semibold-italic text-normal my-4',
                            ])} ${cx({ 'px-2': isMobileView && disableOldSkuBelow })}`}
                        >
                            {bopisIncentive.eligibilityMessage}
                        </p>
                    </div>
                ) : null
            );
        };
        const displayBreadCrumb = () => (
            <ErrorBoundary>
                <PDPBreadcrumbs ppId={ppId} query={query} />
            </ErrorBoundary>
        );

        const mixAndMatchBlock = () => {
            return (
                <ErrorBoundary>
                    <div>
                        {!isEmpty(homeDivision) &&
                        mixAndMatchDivisions.includes(homeDivision) &&
                        !isMTMOrVdata &&
                        !detectisIE() ? (
                            <MixandMatch
                                productDetails={productDetails}
                                outfitsData={this.outfitsData}
                                jumpLink={this.jumpLinkImage}
                                disableShopTheLookForCollection={get(
                                    featureFlags,
                                    'disableShopTheLookForCollection',
                                    false
                                )}
                            />
                        ) : null}
                    </div>
                </ErrorBoundary>
            );
        };

        const renderTitleSection = () => (
            <div
                className={cx('sm12', 'md12', 'lg12', 'xl12', 'productTitleContainer')}
                data-automation-id="product-title"
            >
                <ErrorBoundary>
                    <ProductTitle
                        dataAutomationId="product-title"
                        className={dt(['lg:!text-lg', 'smMd:!text-base'])}
                        title={productDetails.name}
                        primary
                        primaryProductDisplay
                        arrivalDisplayTitle={get(productDetails, 'arrival', '')}
                    />
                </ErrorBoundary>
                {brand.brandPageUrl && get(featureFlags, 'enableBrandLink', true) ? (
                    <section>
                        <ErrorBoundary>
                            <BrandLink productDetails={productDetails} />
                        </ErrorBoundary>
                    </section>
                ) : null}
                <section>
                    <div className={cx('productDetailsInfo')}>
                        <ErrorBoundary>
                            <ProductModelNumber />
                        </ErrorBoundary>
                    </div>
                </section>
                {disableOldSkuBelow ? (
                    <ErrorBoundary>
                        <div
                            className={cx('col10', 'noPad', 'bvSummary-wrapper')}
                            data-automation-id="bazaar-voice"
                        >
                            {get(featureFlags, 'bazaarVoice', true) && (
                                <BVSummary productDetails={productDetails} primaryProductDisplay />
                            )}
                        </div>
                        {productId ? <span className={cx('productId')}>{productId}</span> : null}
                    </ErrorBoundary>
                ) : null}
            </div>
        );
        let pdpDivision = '';
        const breadcrumbs = get(productDetails, 'breadCrumbInfo.breadcrumbs', []);
        /* istanbul ignore next */
        if (breadcrumbs.length) {
            pdpDivision = get(breadcrumbs, '[1].breadCrumbLabel', '');
        }
        const templateType = get(this.props.pdpProductType, 'templateType', '');
        const isBNPLeligible = get(selectedProductLot, '[0].buyNowPayLaterEligible', false);
        const isJumpLinkAvailable =
            !isEmpty(this.state.jumpLinkImage) || !isEmpty(this.state.isShopTheLook);

        const freestarAdClasses = [
            cx(
                !get(featureFlags, 'enableFreestarAlignment', true) && 'bv-ad',
                !get(featureFlags, 'enableFreestarAlignment', true) && 'col3'
            ),
            dt([
                get(featureFlags, 'enableFreestarAlignment', true) && 'inline-block',
                get(featureFlags, 'enableFreestarAlignment', true) && 'px-2',
            ]),
        ].join(' ');
        const {
            enableHttpsCanonical = true,
            displayAds = true,
            enableS1IrisPromoBanner = false,
            productImageResizeOnScroll = false,
        } = featureFlags;
        return (
            <>
                <ErrorBoundary>
                    <EcoRebatesModal
                        automationId="ecorebates-block"
                        uiContext="PDP"
                        fromMiniPDP={false}
                    />
                </ErrorBoundary>
                <ErrorBoundary>
                    {featureFlags.performURLProfanity ? (
                        <Canonicalize
                            productDetails={productDetails}
                            location={this.props.location}
                        />
                    ) : null}
                </ErrorBoundary>
                <ErrorBoundary>
                    <Metadata
                        productDetails={productDetails}
                        preferences={preferences}
                        lotPriceInventory={selectedLotPrice}
                        location={this.props.location}
                        httpsCanonical={enableHttpsCanonical}
                        deviceType={deviceType}
                    />
                </ErrorBoundary>
                <section
                    className={`${cx('pdp-container')} ${dt(['px-6', 'smOnly:pt-6', 'bg-white'])}`}
                >
                    <section
                        className={cx(rowClasses, 'topPromotionalBanner')}
                        data-automation-id="pdp-promotional-banner"
                    >
                        <ErrorBoundary>
                            {enableS1IrisPromoBanner ? (
                                <IrisS1PromoBanner
                                    productDetails={productDetails}
                                    ppId={ppId}
                                    tmplType=""
                                    topPromotionalBanner
                                />
                            ) : (
                                <></>
                            )}
                        </ErrorBoundary>
                    </section>
                    <section
                        className={`${cx(rowClasses, 'breadcrumbsRow')} ${dt([
                            'smMd:py-0',
                            'lg:pt-1.5',
                            'lg:pb-2',
                            'sm:!min-h-0',
                        ])} `}
                        data-automation-id="breadcrumb-tite-container"
                    >
                        {displayBreadCrumb()}
                        {recPageType === PLA_REC_PAGE_TYPE ? (
                            <ErrorBoundary>
                                {featureFlags.plaRecommendation ? (
                                    <section className={cx('certona-row')}>
                                        <CertonaZone
                                            page="PDP"
                                            slotDetails={{
                                                pageType: recPageType,
                                                attributes: {
                                                    itemid: ppId,
                                                    recommendations: true,
                                                    pdpDivision,
                                                },
                                                loader: 'certona',
                                                slotId: 'pla1_rr',
                                            }}
                                            isPLAEnabled
                                            schemasToRender={['pla1_rr']}
                                        />
                                    </section>
                                ) : null}
                            </ErrorBoundary>
                        ) : (
                            ''
                        )}
                        {disableOldSkuBelow && isMobileView ? renderTitleSection() : null}
                    </section>

                    {isMobileView &&
                    get(featureFlags, 'enableBopisIncentiveOnTopSec', false) &&
                    disableOldSkuBelow
                        ? displayBopisIncentive()
                        : null}
                    {isMobileView && disableOldSkuBelow
                        ? this.renderPricingStack(
                              ppId,
                              selectedLotPrice,
                              deviceType,
                              isBNPLeligible
                          )
                        : null}

                    {isMobileView && !isOrientationLandscape && !disableOldSkuBelow && (
                        <div
                            className={`${dt(['smOnly:px-0', 'smOnly:pb-2'])} ${cx('bazarVoice')}`}
                        >
                            <ErrorBoundary>
                                <div
                                    className={cx('col10', 'noPad', 'bvSummary-wrapper')}
                                    data-automation-id="bazaar-voice"
                                >
                                    {get(featureFlags, 'bazaarVoice', true) && (
                                        <BVSummary
                                            productDetails={productDetails}
                                            primaryProductDisplay
                                        />
                                    )}
                                </div>
                                {productId ? (
                                    <span
                                        className={`${cx('productId', 'col2')} ${dt([
                                            'smOnly:pt-px',
                                        ])}`}
                                    >
                                        {productId}
                                    </span>
                                ) : null}
                            </ErrorBoundary>
                        </div>
                    )}
                    <section className={productImageSectionClasses}>
                        <div
                            className={`${cx(
                                'sm12',
                                'md6',
                                'lg7',
                                'xl7',
                                'productImageWrapper'
                            )} ${dt([
                                'smOnly:!w-[calc(100%+48px)]',
                                'smOnly:-mx-6',
                                'smOnly:!p-0',
                                'md:!pl-0',
                                'mdOnly:!pr-2',
                                'lg:!pr-[23px]',
                            ])}`}
                            data-automation-id="image-block"
                        >
                            <ErrorBoundary>
                                <ProductImage
                                    resizeOnScroll={productImageResizeOnScroll}
                                    productDetails={productDetails}
                                    dataAutomationId="product-image-block"
                                    virtualTryOnEnabled={data.enabled}
                                />
                            </ErrorBoundary>
                            {featureFlags.enablePDPVirtualTryOn ? (
                                <ErrorBoundary>
                                    {templateType === templateTypes.BEAUTY ? <VTO /> : null}
                                </ErrorBoundary>
                            ) : null}
                        </div>
                        <div
                            className={[
                                cx('lg5', 'xl5', 'productOptionBlock'),
                                dt([
                                    'md:!pr-0',
                                    'md:!pl-2',
                                    'smOnly:!px-0',
                                    'smOnly:pt-6',
                                    'mdOnly:pl-2',
                                    'smOnly:w-full',
                                    'mdOnly:w-1/2',
                                    'smMd:inline-block',
                                    'align-top',
                                ]),
                            ].join(' ')}
                            data-automation-id="product-content-block"
                        >
                            <div>
                                {/* For breakpoints other than mobile  */}
                                {(!isMobileView || isOrientationLandscape) && !disableOldSkuBelow && (
                                    <div className={cx('bazarVoice')}>
                                        <ErrorBoundary>
                                            <div
                                                className={cx(
                                                    'col10',
                                                    'noPad',
                                                    'bvSummary-wrapper'
                                                )}
                                                data-automation-id="bazaar-voice"
                                            >
                                                {get(featureFlags, 'bazaarVoice', true) && (
                                                    <BVSummary
                                                        productDetails={productDetails}
                                                        primaryProductDisplay
                                                    />
                                                )}
                                            </div>
                                            {productId ? (
                                                <span className={cx('productId', 'col2')}>
                                                    {productId}
                                                </span>
                                            ) : null}
                                        </ErrorBoundary>
                                    </div>
                                )}
                                {!isMobileView && disableOldSkuBelow ? renderTitleSection() : null}
                                {!isMobileView &&
                                disableOldSkuBelow &&
                                get(featureFlags, 'enableBopisIncentiveOnTopSec', false)
                                    ? displayBopisIncentive()
                                    : null}
                                {!isMobileView && disableOldSkuBelow
                                    ? this.renderPricingStack(
                                          ppId,
                                          selectedLotPrice,
                                          deviceType,
                                          isBNPLeligible
                                      )
                                    : null}
                                <ErrorBoundary>
                                    {this.props.virtualTryOn.vtoEligibilityForPP &&
                                    templateType === templateTypes.BEAUTY ? (
                                        <VTOToggle />
                                    ) : null}
                                </ErrorBoundary>

                                <ErrorBoundary>
                                    <ProductOptions
                                        query={query}
                                        productDetails={productDetails}
                                        analytics={analytics}
                                        automationId="product-dimensions-block"
                                    />
                                </ErrorBoundary>
                                {!disableOldSkuBelow && renderTitleSection()}
                                {!disableOldSkuBelow &&
                                get(featureFlags, 'enableBopisIncentiveOnTopSec', false)
                                    ? displayBopisIncentive()
                                    : null}
                                {!disableOldSkuBelow &&
                                    this.renderPricingStack(
                                        ppId,
                                        selectedLotPrice,
                                        deviceType,
                                        isBNPLeligible
                                    )}
                                {slot4}
                                {slot2}
                                {this.state.errorBannerMessage &&
                                    featureFlags.enableErrorSizing && (
                                        <ProductOptionsErrorBanner
                                            query={query}
                                            errorBannerMessage={this.state.errorBannerMessage}
                                        />
                                    )}
                                <section className={cx('col12', 'selectionContainer')}>
                                    <section
                                        className={[
                                            cx('qtyCartContainer'),
                                            dt(['flex', 'items-center', 'gap-4']),
                                        ].join(' ')}
                                    >
                                        <div
                                            className={[
                                                cx('sm3', 'md3', 'lg2', 'xl2', 'quantity'),
                                                dt(['sm:!w-20']),
                                            ].join(' ')}
                                        >
                                            <ErrorBoundary>
                                                <Quantity
                                                    query={query}
                                                    automationId="product-quantity-block"
                                                    maxQuantity={quantityDropDownValue}
                                                    disabled={quantityDropDownValue === 1}
                                                />
                                            </ErrorBoundary>
                                        </div>
                                        <div
                                            className={[
                                                cx(
                                                    'sm9',
                                                    'md9',
                                                    'lg10',
                                                    'xl10',
                                                    'buttonContainer',
                                                    {
                                                        btnSpacer: isDesktopView,
                                                    }
                                                ),
                                                dt(['smMd:!p-0', 'smMd:!w-full']),
                                            ].join(' ')}
                                        >
                                            <div
                                                className={[
                                                    cx({
                                                        cartBtnSocialWrapper: isDesktopView,
                                                    }),
                                                    dt(['md:flex']),
                                                ].join(' ')}
                                            >
                                                <div
                                                    className={cx(
                                                        { col6: isDesktopView },
                                                        { col8: !isDesktopView },
                                                        'cartBtn'
                                                    )}
                                                >
                                                    <ErrorBoundary>
                                                        <AddToCart
                                                            query={query}
                                                            sticky={featureFlags.stickyAddToCart}
                                                            errorBannerMessage={
                                                                this.state.errorBannerMessage
                                                            }
                                                            updateErrorBannerMessage={(val) => {
                                                                this.setState({
                                                                    errorBannerMessage: val,
                                                                });
                                                            }}
                                                        />
                                                    </ErrorBoundary>
                                                </div>
                                            </div>
                                            <div className={cx('addToCartMessage')}>
                                                <ErrorBoundary>
                                                    <Messages
                                                        messages={this.props.addToCartMessages}
                                                    />
                                                </ErrorBoundary>
                                            </div>
                                        </div>
                                    </section>
                                    {slot1}
                                </section>
                            </div>
                            {get(featureFlags, 'enableStyliticsJumplink', true) &&
                                !isEmpty(homeDivision) && (
                                    <div className={dt(['lg:pt-4', 'smMd:w-full'])}>
                                        <a
                                            id="stylitics-jumplink"
                                            className={dt(['hidden', 'lg:hover:cursor-pointer'])}
                                            onClick={() => {
                                                this.scrollToShopTheLookOnJumplinkClick();
                                            }}
                                        >
                                            {isJumpLinkAvailable && (
                                                <div
                                                    className={dt([
                                                        'flex',
                                                        'justify-center',
                                                        'items-center',
                                                        'gap-8',
                                                        'lg:w-[396px]',
                                                        'h-[99px]',
                                                        'border',
                                                        'border-solid',
                                                        'border-gray-15',
                                                        'rounded-lg',
                                                    ])}
                                                >
                                                    <div
                                                        className={dt(['w-20', 'h-20'])}
                                                        data-automation-id="at-jumplinks-thumbnail-container"
                                                    >
                                                        {isJumpLinkAvailable && (
                                                            <img
                                                                className={dt([
                                                                    'h-full',
                                                                    'w-full',
                                                                    'object-contain',
                                                                ])}
                                                                data-automation-id="at-jumplinks-thumbnail"
                                                                src={
                                                                    (this.state.jumpLinkImage &&
                                                                        this.state.jumpLinkImage[0]
                                                                            ?.dataset?.src) ||
                                                                    (this.state.jumpLinkImage &&
                                                                        this.state.jumpLinkImage[0]
                                                                            ?.src) ||
                                                                    (this.state.isShopTheLook &&
                                                                        this.state.isShopTheLook[0]
                                                                            ?.image_url)
                                                                }
                                                                alt="jumpLinkImage"
                                                            />
                                                        )}
                                                    </div>
                                                    <div
                                                        className={`${cx('jumpLinkText')} ${dt([
                                                            'text-lg',
                                                            'leading-7',
                                                            'font-semibold',
                                                        ])}`}
                                                        data-automation-id="at-jumplinks-text"
                                                    >
                                                        {HOW_TO_STYLE_IT}
                                                    </div>
                                                    <div
                                                        className={dt([
                                                            'w-12',
                                                            'h-12',
                                                            'flex',
                                                            'justify-center',
                                                            'items-center',
                                                            'hover:border',
                                                            'hover:border-solid',
                                                            'hover:border-[#F2F2F2]',
                                                            'hover:bg-[#F2F2F2]',
                                                            'hover:rounded-full',
                                                        ])}
                                                        data-automation-id="at-jumplinks-arrow"
                                                    >
                                                        <Icon
                                                            iconType="svg"
                                                            width="16px"
                                                            height="24px"
                                                            viewBox="0 0 16 24"
                                                            pathClassName={dt(['mr-1'])}
                                                        >
                                                            <IconArrowRight />
                                                        </Icon>
                                                    </div>
                                                </div>
                                            )}
                                        </a>
                                    </div>
                                )}
                        </div>
                    </section>
                    <BelowTheFold>
                        <KeyFeatures featureAttributes={valuesList} />
                        <ErrorBoundary>
                            <div className={dt(['pb-10', 'flex', 'flex-col'])}>
                                <DescriptionAndShipping />
                            </div>
                        </ErrorBoundary>
                        {isCollection && query ? (
                            <ErrorBoundary>
                                {get(featureFlags, 'productCollection', true) ? (
                                    <ProductCollection
                                        productDetails={productDetails}
                                        enrId={query.enrId}
                                        automationId="product-collection"
                                        location={this.props.location}
                                        showShopTheCollection={this.state.isShopTheLook}
                                        disableShopTheLookForCollection={get(
                                            featureFlags,
                                            'disableShopTheLookForCollection',
                                            false
                                        )}
                                        removeLinkPrefix={featureFlags.removeLinkPrefix}
                                    />
                                ) : null}
                            </ErrorBoundary>
                        ) : null}
                        <ErrorBoundary>
                            {!isEmpty(homeDivision) &&
                            !mixAndMatchDivisions.includes(homeDivision) &&
                            !isMTMOrVdata &&
                            get(featureFlags, 'enableShopTheLook', true) &&
                            !detectisIE() ? (
                                <ShopTheLook
                                    productDetails={productDetails}
                                    outfitsData={this.outfitsData}
                                    jumpLink={this.jumpLinkImage}
                                    disableShopTheLookForCollection={get(
                                        featureFlags,
                                        'disableShopTheLookForCollection',
                                        false
                                    )}
                                />
                            ) : null}
                        </ErrorBoundary>
                        {deviceType.isDesktop &&
                            get(featureFlags, 'enableMixAndMatch', true) &&
                            mixAndMatchBlock()}
                        {!deviceType.isDesktop &&
                            get(featureFlags, 'enableMixAndMatchMobile', true) &&
                            mixAndMatchBlock()}
                        {templateType !== templateTypes.BUNDLE && (
                            <section
                                className={`${cx('lg8', 'xl8', 'md10', 'sm12')} ${dt([
                                    'sm:!block',
                                    'mx-auto',
                                    'text-center',
                                    'lg:!px-1',
                                    'smMd:!px-0',
                                ])}`}
                            >
                                <MerchantMarketing
                                    productDetails={productDetails}
                                    automationId="merchant-marketing-block"
                                />
                            </section>
                        )}
                        {isDesktopView ? (
                            <section
                                className={`${cx('section')} ${dt(['sm:!my-0'])}`}
                                data-automation-id="desktop-product-compare"
                            >
                                <div
                                    className={`${cx(
                                        'small12',
                                        'medium12',
                                        'large12',
                                        'extraLarge12',
                                        rowClasses
                                    )} ${dt(['sm:pt-0'])}`}
                                >
                                    <ErrorBoundary>
                                        <ProductInfoDesktop
                                            dataAutomationId="product-info"
                                            productDetails={productDetails}
                                            pageType={recPageType}
                                            pTmplType={query.pTmplType}
                                        />
                                    </ErrorBoundary>
                                </div>
                            </section>
                        ) : (
                            <section
                                className={`${cx('section')} ${dt(['sm:!my-0'])}`}
                                data-automation-id="mobile-product-compare"
                            >
                                <div
                                    className={`${cx(
                                        'small12',
                                        'medium12',
                                        'large12',
                                        'extraLarge12',
                                        rowClasses
                                    )} ${dt(['sm:pt-0'])}`}
                                >
                                    <ErrorBoundary>
                                        <ProductInfoMobile
                                            dataAutomationId="product-info"
                                            productDetails={productDetails}
                                            pageType={recPageType}
                                            featureFlags={featureFlags}
                                        />
                                    </ErrorBoundary>
                                </div>
                            </section>
                        )}
                        <ErrorBoundary>
                            {featureFlags.productCartridgeZone4 ? (
                                <section
                                    className={cx('certona-row')}
                                    data-automation-id="pdp-reczones-block"
                                >
                                    <CertonaZone
                                        page="PDP"
                                        slotDetails={{
                                            pageType: recPageType,
                                            attributes: {
                                                itemid: ppId,
                                                recommendations: true,
                                                pdpDivision,
                                            },
                                            loader: 'certona',
                                            automationId: 'pdp-reczones',
                                            slotId: 'product4_rr',
                                        }}
                                        schemasToRender={['product4_rr']}
                                        bottomPadding={dt(['mb-10'])}
                                    />
                                </section>
                            ) : null}
                        </ErrorBoundary>
                        {/* For Ensighten team to inject display ads section. */}
                        {!displayAds ? null : (
                            <StaticContainer>
                                {!isNative && (
                                    <div
                                        className={`${cx('bv-ad-wrapper', rowClasses)} ${dt([
                                            '!pt-2',
                                            '!pb-2',
                                        ])}`}
                                    >
                                        {enableFreestarAdComponent && isTrackingCookieActive && (
                                            <>
                                                <FreestarAd
                                                    placementName="div-gpt-ad-jcpenney_pdp-1"
                                                    className={freestarAdClasses}
                                                />
                                                <FreestarAd
                                                    placementName="div-gpt-ad-jcpenney_pdp-2"
                                                    className={freestarAdClasses}
                                                />
                                                <FreestarAd
                                                    placementName="div-gpt-ad-jcpenney_pdp-3"
                                                    className={freestarAdClasses}
                                                />
                                            </>
                                        )}
                                    </div>
                                )}
                            </StaticContainer>
                        )}
                    </BelowTheFold>
                </section>
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    preferences: selectPreferences(state),
    productDetails: state.productDetails,
    deviceType: state.context ? state.context.deviceType : {},
    analytics: state.Analytics,
    addToCartMessages: state.messages?.[ADD_TO_CART_MESSAGES_ID],
    selectedProductLot: selectedProductSkus(false)(state),
    selectedLotPrice: productLotSelector(false)(state),
    pdpProductType: selectProductType(ownProps.fromMiniPDP)(state),
    bopisIncentiveProductEligibility: bopisIncentiveProductEligibilitySelector(
        ownProps.fromMiniPDP
    )(state),
    isNative: state.context ? state.context.isNative : {},
    virtualTryOn: getVirtualTryOnData(state),
    recPageType: selectRecPageType(state),
    quantityDropDownValue: getMOQDropdownValue(false)(state),
});

export default connect(mapStateToProps, null)(memo(Regular));
